module.exports = __webpack_public_path__ + "img/telegram.b37d6df3.png";